<template>
    <header
      class="barocare-header"
      :class="{'navigation': true, 'scrolled': isScrolled}"
      id="header"
    >
        <div class="container">
            <h1 id="logo">
              <a @click.prevent="scrollToTop" href="#home">
                <img  src="../../assets/pc_barocare_new/logo.png" alt="바로돌봄"/>
              </a>
            </h1>
            <ul class="gnb">
                <li><a @click.prevent="scrollToSection($event, 'service-intro')" href="#service-intro">서비스 소개</a></li>
                <li><a @click.prevent="scrollToSection($event, 'company-intro')" href="#company-intro">회사 소개</a></li>
                <li><a @click.prevent="scrollToSection($event, 'service-use')" href="#service-use">이용하기</a></li>
                <li><a @click.prevent="scrollToSection($event, 'inquiry')" href="#inquiry">도입문의</a></li>
            </ul>
            <div class="btn-area">
              <a
                href="https://play.google.com/store/apps/details?id=com.soldocbarocare"
                target="_blank" title="새창"
                class="btn-app-download"
              >
              <img  src="../../assets/pc_barocare_new/ico-app-download.png" alt=""/>
              앱 다운로드</a>
              <a
                href="https://partner.soldoc.co.kr/home?type=b2b"
                target="_blank" title="새창"
                class="btn-partnership"
              >제휴 신청</a>
            </div>
        </div>
    </header>       
</template>

<script>
export default {
  data() {
    return {
      isScrolled: false
    };
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 0) {
        this.isScrolled = true;
      } else {
        this.isScrolled = false;
      }
    },
    scrollToTop(event) {
      window.history.pushState({}, '', event.target.closest('a').href);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    scrollToSection(event, sectionId) {
      const section = document.getElementById(sectionId);
      if (section) {
        const yOffset = -80; // 헤더 높이 만큼 오프셋 조정
        const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
        
        window.history.pushState({}, '', event.target.closest('a').href);
        window.scrollTo({
          top: y,
          // behavior: 'smooth'
        });
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>


<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/pc_barocare_new/BarocareHeader.vue